/**
 * ÉTAT VIDE — anatomie PARTAGÉE (§24.9sexies-ter e) : tuile d'icône + titre gras + note qui explique
 * pourquoi c'est vide et ce qui le remplira — jamais une ligne de texte nue (§23.0). Valeurs portées
 * VERBATIM du composant pilote de la Console (désigné source par le SPEC), lues par `ui-web/empty-state`.
 * Le pendant RN (`ui-native/empty-state`) garde sa propre anatomie (grammaire tablette, §24.1) — c'est
 * le SENS (vide honnête + explication) qui est commun, pas la géométrie.
 */
export const EMPTY_STATE = {
  padding: '34px 20px',
  tile: 50,
  tileRadius: 16,
  tileGap: 13,
  iconSize: 25,
  iconStroke: 1.6,
  titleSize: 13.5,
  titleWeight: 700,
  noteSize: 12,
  noteMaxWidth: 340,
  actionGap: 12,
  /** Variante resserrée (cartes latérales / sections de dashboard). */
  compact: { padding: '20px 14px', tile: 42, tileRadius: 13, tileGap: 10, titleSize: 12.5, noteSize: 11.5 },
} as const;
